var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcBankAccountType = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 34,
  height: 34.068,
  viewBox: "0 0 34 34.068",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_294",
  "data-name": "Path 294",
  d: "M360.418,116.635v33.338l17.691.094s-3.812-3.484-4.014-7.817c-.048-3.4.516-6.783,3.156-9.453,2.938-3.071,6.408-3.947,10.264-3.681a13.182,13.182,0,0,1,5.994,2.5l.02-14.981Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fill"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-2"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fill-2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-3"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fill-3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-4"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fill-4"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-5"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fill-5"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-6"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fill-6"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_bank_account_type",
  transform: "translate(20750 -1241.996)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_320",
  "data-name": "Rectangle 320",
  width: 34,
  height: 34,
  transform: "translate(-20750 1241.996)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_15",
  "data-name": "Mask Group 15",
  transform: "translate(-21110 1125.996)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_978",
  "data-name": "Group 978",
  transform: "translate(21138.162 -1187.482)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_321",
  "data-name": "Rectangle 321",
  transform: "translate(-20777 1334)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0H30a1,1,0,0,1,1,1V3a0,0,0,0,1,0,0H0A0,0,0,0,1,0,3V1A1,1,0,0,1,1,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,.5H30a.5.5,0,0,1,.5.5V2.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V1A.5.5,0,0,1,1,.5Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_322",
  "data-name": "Rectangle 322",
  transform: "translate(-20775 1332)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0H26a1,1,0,0,1,1,1V3a0,0,0,0,1,0,0H0A0,0,0,0,1,0,3V1A1,1,0,0,1,1,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,.5H26a.5.5,0,0,1,.5.5V2.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V1A.5.5,0,0,1,1,.5Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_323",
  "data-name": "Rectangle 323",
  transform: "translate(-20775 1316.307)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H27a0,0,0,0,1,0,0V2a1,1,0,0,1-1,1H1A1,1,0,0,1,0,2V0A0,0,0,0,1,0,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h26a0,0,0,0,1,0,0V2a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,2V.5A0,0,0,0,1,.5.5Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_293",
  "data-name": "Path 293",
  transform: "translate(-20777 1313.825)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.457-9.342,30.838,3.482h-31Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 15.45213317871094 -8.044353485107422 L 2.631628036499023 2.482418060302734 L 28.07705307006836 2.482418060302734 L 15.45213317871094 -8.044353485107422 M 15.45703029632568 -9.342281341552734 L 30.837890625 3.482418060302734 L -0.162109375 3.482418060302734 L 15.45703029632568 -9.342281341552734 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_324",
  "data-name": "Rectangle 324",
  transform: "translate(-20772 1318.786)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  id: "fill",
  d: "M.5,0h0A.5.5,0,0,1,1,.5V13.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.5A.5.5,0,0,1,.5,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.75h1M0.75,0v13.7952880859375M1,13.0452880859375h-1M0.25,13.7952880859375v-13.7952880859375",
  fill: "none",
  clipPath: "url(#clip)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_325",
  "data-name": "Rectangle 325",
  transform: "translate(-20768 1318.786)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  id: "fill-2",
  d: "M.5,0h0A.5.5,0,0,1,1,.5V13.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.5A.5.5,0,0,1,.5,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.75h1M0.75,0v13.7952880859375M1,13.0452880859375h-1M0.25,13.7952880859375v-13.7952880859375",
  fill: "none",
  clipPath: "url(#clip-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_326",
  "data-name": "Rectangle 326",
  transform: "translate(-20764 1318.786)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  id: "fill-3",
  d: "M.5,0h0A.5.5,0,0,1,1,.5V13.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.5A.5.5,0,0,1,.5,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.75h1M0.75,0v13.7952880859375M1,13.0452880859375h-1M0.25,13.7952880859375v-13.7952880859375",
  fill: "none",
  clipPath: "url(#clip-3)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_327",
  "data-name": "Rectangle 327",
  transform: "translate(-20760 1318.786)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  id: "fill-4",
  d: "M.5,0h0A.5.5,0,0,1,1,.5V13.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.5A.5.5,0,0,1,.5,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.75h1M0.75,0v13.7952880859375M1,13.0452880859375h-1M0.25,13.7952880859375v-13.7952880859375",
  fill: "none",
  clipPath: "url(#clip-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_328",
  "data-name": "Rectangle 328",
  transform: "translate(-20756 1318.786)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  id: "fill-5",
  d: "M.5,0h0A.5.5,0,0,1,1,.5V13.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.5A.5.5,0,0,1,.5,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.75h1M0.75,0v13.7952880859375M1,13.0452880859375h-1M0.25,13.7952880859375v-13.7952880859375",
  fill: "none",
  clipPath: "url(#clip-5)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_329",
  "data-name": "Rectangle 329",
  transform: "translate(-20752 1318.786)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  id: "fill-6",
  d: "M.5,0h0A.5.5,0,0,1,1,.5V13.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.5A.5.5,0,0,1,.5,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0.75h1M0.75,0v13.7952880859375M1,13.0452880859375h-1M0.25,13.7952880859375v-13.7952880859375",
  fill: "none",
  clipPath: "url(#clip-6)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_60",
  "data-name": "Ellipse 60",
  transform: "translate(-20764 1310)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.8
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.1,
  fill: "none"
})))), /*#__PURE__*/React.createElement("text", {
  id: "_",
  "data-name": "$",
  transform: "translate(-20732 1269.996)",
  fill: "#fff",
  fontSize: 11,
  fontFamily: "Roboto-Regular, Roboto"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "$")), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_348",
  "data-name": "Rectangle 348",
  transform: "translate(-20724 1268.996)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_349",
  "data-name": "Rectangle 349",
  transform: "translate(-20724 1265.996)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 6,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_350",
  "data-name": "Rectangle 350",
  transform: "translate(-20724 1262.996)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 6,
  fill: "none"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcBankAccountType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_bank_account_type.445ff834b7276a0eee0edfc49916debf.svg";